import Link from 'gatsby-link';
import React from 'react';

import Timeframe from './timeframe.js';

export default ({ events }) =>
  <div>
    {events.map(event =>
      <div className="list-item" key={event.permalink}>
        {event.image ?
          <img className="teaser-image" src={event.image} />
          :
          null
        }

        <div className="emphasized">
          <Link to={`/event/${event.permalink}/`}>
            {event.title}
          </Link>
        </div>

        <div className="additional">
          <Timeframe event={event} />
          &nbsp;
          {event.address}
        </div>
        <div dangerouslySetInnerHTML={{ __html: event.fields.abstractHtml }}/>
      </div>
    )}
  </div>
;


export const fragments = graphql`
  fragment EventListingFields on EventsYaml {
    address
    end_date
    end_time
    fields {
      abstractHtml
    }
    image
    permalink
    start_date
    start_time
    title
  }
`;



// WEBPACK FOOTER //
// ./src/components/event-listing.js